






























import { formatForDatePicker } from '@/common/format'

export default
  filters:
    formatForDatePicker: (date) ->
      return formatForDatePicker(date)

  props:
    dateVal:
      type: String
    showCurrent:
      type: String
    dateArgs:
      type: Object
    rightFit:
      type: Boolean
      default: false
    isPartner:
      type: Boolean
      default: false

  mounted: () ->
    @date = @dateVal

  methods: {
    handleDateChange: (date) ->
      this.$emit('handleDateChange', date, this.dateArgs)
      this.$emit('close')
    handleOutSideClick: () ->
      this.$emit('handleOutSideClick')
    handleClose: () ->
      this.$emit('close')
    deleteDate: () ->
      this.$emit('handleDateChange', null, this.dateArgs)
      this.$emit('close')
  }
